// Module
var code = `<i class="fa fa-lock" uib-tooltip="{{ 'Generic.ReadOnly' | translate }}" tooltip-placement="bottom"></i> `;
// Exports
module.exports = code;